import React, { FunctionComponent, useContext } from 'react';
import { FollowButtons } from 'features/chat/components/FollowButtons';
import { SupportButton } from 'components/Support/SupportButton';
import { ChannelSocialLinks } from 'features/channel/components/ChannelSocialLinks';
import { useCurrentUser } from 'features/current-user/hooks';
import { UserAgentContext } from 'features/user-agent/userAgent';
import { IconButton } from 'components/Buttons/IconButton';
import { useDispatch } from 'react-redux';
import { toggleSearchVisibility } from 'features/search/searchSlice';
import { useAppSelector } from 'hooks/redux';
import { ChannelNetworkModal } from '../ChannelNetwork/ChannelNetworkModal';
import { matchPath, useLocation } from 'react-router-dom';

export const ChannelInfo: FunctionComponent = () => {
  const channel = useAppSelector((state) => state.channel.channelDetails);
  const currentUser = useCurrentUser();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const isNetworkPath = matchPath('/network', pathname);
  const channelHomepageEnabled = useAppSelector(
    (state) => state.channel.channelDetails?.channelHomepageEnabled
  );
  const channelNetworkOwner = useAppSelector(
    (state) => state.channel.channelDetails?.networkOwner
  );

  const { isNativeAppWebview, isCreatorAppWebview, isListenerAppWebview } =
    useContext(UserAgentContext);

  const showSearch = () => {
    dispatch(toggleSearchVisibility(true));
  };

  if (channelNetworkOwner) {
    return null;
  }

  if (isListenerAppWebview && isNetworkPath) {
    return null;
  }

  if (!channel || isCreatorAppWebview || !channelHomepageEnabled) {
    return null;
  }

  return (
    <div className="xs:tw-flex [.app-listener_&]:tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 md:tw-px-8 md:tw-py-4 tw-border-line-color tw-border-solid tw-border-0 tw-border-t-[1px] tw-border-b-[1px] [.app-listener_&]:tw-border-t-0">
      <div className="tw-flex tw-items-center tw-mt-2 [.app-listener_&]:tw-mt-0 xs:tw-mt-0 [&>button]:-tw-ml-2 tw-mr-auto">
        <ChannelNetworkModal />
        {!isNativeAppWebview && (
          <h1 className="tw-truncate tw-mb-0 tw-text-2xl sm:tw-text-3xl tw-text-bold">
            {channel.username}
          </h1>
        )}
      </div>
      <div className="tw-flex tw-items-center tw-gap-8 [.ios_&]:tw-gap-4 tw-list-none">
        <SupportButton showAslink />
        {!channel.networkOwner && (
          <FollowButtons
            showAslink
            selectedProfileId={channel.ownerId}
            followedIds={(currentUser && currentUser.followedUserIds) || []}
          />
        )}
        <ChannelSocialLinks iconList={true} />
      </div>
      {isNativeAppWebview && (
        <div className="tw-ml-auto tw-relative -tw-right-[10px]">
          <IconButton
            label={'Show search'}
            onClick={showSearch}
            size={'small'}
            icon={'search'}
            noBackground={true}
          />
        </div>
      )}
    </div>
  );
};
